import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, BaseForm, BaseFormService, MessageService } from '../../../core';

import { ItemUnidade } from '../item-unidade';
import { ItemUnidadeCrudHttpService } from '../services';

@Component({
    selector: 'sgt-item-unidade-form',
    templateUrl: './item-unidade-form.component.html',
    styleUrls: ['./item-unidade-form.component.less']
})
export class ItemUnidadeFormComponent implements BaseForm<ItemUnidade>, OnInit {
    entity: ItemUnidade;
    editMode: boolean;
    @ViewChild('form') form: NgForm;

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private messageService: MessageService,
                private baseFormService: BaseFormService,
                private itemUnidadeCrudHttpService: ItemUnidadeCrudHttpService) { }

    ngOnInit() {
        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                this.insert();
            } else {
                this.edit(id);
            }
        })
    }

    load(id: number) {
        this.itemUnidadeCrudHttpService.load(id)
            .subscribe(
                entity => this.entity = entity,
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a unidade', error);
                    this.cancel();
                }
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new ItemUnidade();
        this.entity.idEmpresa = this.authService.getIdEmpresa();
    }

    edit(id: number) {
        this.editMode = true;
        this.load(id);
    }


    save() {
        this.baseFormService.save<ItemUnidade>(this.entity, this.form, this.editMode, this.itemUnidadeCrudHttpService)
            .then(entity => {
                this.messageService.success('', 'Unidade salva com sucesso');
                this.afterSave(entity);
            })
            .catch(error => {});
    }

    afterSave(entity: ItemUnidade) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }
}
